import { Target } from "react-feather";
import { Accessing, Automated, Boost, Empower, Engage, Engaging, Handling, Managing, Marketing, Support, Taraget, YogaMain, YogaMainImage } from "../assets/images/images";

const yogaData = {
    heading: "The Best Software for Yoga Studios",
    subtitle:
        "EasyMembr offers seamless billing, centralized member management, and efficient staff check-in. EasyMembr supports flexible membership plans and easy class booking, complemented by timely reminders to keep members engaged and boost attendance.",
    trialText: "Get Started Now",
    demoText: "Book A Demo",
    imageSrc: YogaMain,
    FeatureHead: "Yoga Studio Management: Easy Scheduling and Client Engagement",
    FeatureDesc: "Discover the key features designed to enhance your yoga business management.",
    FeaturesDetails: [
        {
            id: 1,
            title: "Automated Scheduling and Booking",
            description: [
                "EasyMembr offers a user-friendly interface that makes the scheduling of yoga classes for both staff and clients, day-to-day operations smoother and more efficient",
                "Easily manage cancellations, rescheduling, and waitlists. The software supports all these adjustments effortlessly, ensuring your studio adapts quickly to client needs and changes.",
                "Clients can book yoga classes anytime through the web portal or mobile app, enhancing convenience for your clients and encouraging more engagement.",
            ],
            image: Automated
        },
        {
            id: 2,
            title: "Managing Client Profiles and Ensuring Data Protection",
            description: [
                "Store client’s contact details, preferences, and attendance history to enhance personalized service.",
                "Use client data to tailor interactions, improving customer satisfaction and loyalty.",
                "Ensure robust data protection and privacy, keeping client information secure and compliant with industry standards.",
            ],
            image: Managing
        },
        {
            id: 3,
            title: "Handling Diverse Payment Methods and Transaction Security",
            description: [
                "Easily integrate with various payment gateways for secure credit card and online payments."
                , "Automate billing, invoicing, and receipt generation, reducing administrative workload."
                , "Efficiently manage memberships and class package payments to improve cash flow consistency. Rotating Blue Circle"
            ],
            image: Handling
        },
        {
            id: 4,
            title: "Accessing Business Insights and Generating Custom Reports",
            description: [
                "Access instant insights into key business metrics like revenue, attendance rates, and client retention.",
                , "Generate detailed, tailored reports to focus on specific aspects of your business."
                , "Use analytics to make decisions, optimizing business performance and strategy.",
            ],
            image: Accessing
        },
        {
            id: 5,
            title: "Engaging Clients and Managing Bookings On-the-Go",
            description: [
                "Branded Web app: Manage bookings, payments, and interactions with the studio through a Web app.",
                "Send updates and reminders to clients, keeping them engaged and informed.",
                "Manage client schedules and check information on the go, enhancing operational flexibility.",
            ],
            image: Engaging
        },
    ],
    HighlighCardDetails: [
        {
            id: 1,
            subtitle: "BEST SOFTWARE",
            title: "Book a Demo Now!",
            description: [
                "Say goodbye to manual management. Try our Yoga class software for free and see the benefits instantly!"
            ],
            // image: "https://fitgymsoftware.com/images/yoga-studio-software/cta-desktop.webp",
            links: [
                "Get Full Access Now!",
                "Book A Demo",
                "Check Pricing"
            ],
        }
    ],

    AdvantageHeadText: "Advantages of EasyMembr Yoga Management Software",
    AdvantageDescText: "EasyMembr Yoga Management Software not only simplifies your work but also significantly enhances client engagement and boosts your business growth.",

    featuresData: [
        {
            title: "Seamless Integration",
            description: [
                "EasyMembr’s customer support team will help you easily migrate all your data from other systems.",
                "Generate detailed financial and operational reports that help you track progress over time.",
                "Customize dashboards to view real-time business metrics, such as revenue, attendance rates, and client engagement."],
            icon: Empower
        },
        {
            title: "Enhanced Client Management and Engagement",
            description: [
                "Manage client profiles, track historical data, and customize communications to enhance client retention and satisfaction.",
                "Use client information to offer personalized classes, discounts, and wellness tips that boost client loyalty.",
                "Send customers yoga tips and offline workout tips to keep them engaged."],
            icon: Engage
        },
        {
            title: "Class Scheduling and Management",
            description: [
                "Easily manage online and in-studio class bookings through a single platform that suits all client preferences.",
                "Automatically update schedules for cancellations and changes, keeping clients and staff informed.",
                "Monitor class sizes, manage waitlists, and ensure optimal attendance through automated tools."],
            icon: Boost
        },
        // {
        //     title: "Targeted Marketing and Communication Tools",
        //     description: [
        //         "Use targeted email marketing campaigns directly from the platform to promote classes, events, and special offers.",
        //         "Enhance client acquisition with customizable referral programs that effectively track and reward client referrals.",
        //         "Send timely reminders, alerts, and promotional messages through integrated SMS and WhatsApp."],
        //     icon: Marketing
        // },
        {
            title: "Customer Support and Performance Analytics",
            description: [
                "EasyMembr offer customer support in various languages.",
                "EasyMembr dedicated team will address your queries and concerns rapidly.",
                "Monitor and evaluate staff performance and improve service quality."],
            icon: Support
        },

    ]

};

export default yogaData;